/**
 * @desc 导出现有库位
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.storageUnit.exportWarehousePosition.Params, options?: any) {
  return updateResponse(
    http(URL + `/storageUnit/exportWarehousePosition`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
